import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { fetchUserInformation } from "../../shared/actions/AuthActions";
import {
  View,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
  Text,
} from "react-native-web";
import { emailValidator, getInitials } from "../../shared/core/utils";
import forGotPasswordApi from "../../shared/services/ForgotPasswordServices";
import Settings from "../../shared/config/Settings";
import ReCAPTCHA from "react-google-recaptcha";
import { appServices } from "../../shared/redux/actions/appServices";
import PortalAlerts from "../../app/components/PortalAlerts";
import { passwordValidator } from "../../shared/core/utils";
const UpdatePassword = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [recaptchToken, setrecaptchToken] = useState("");
  const recaptchaRef = useRef();
  const { UpdatePasswordData, isUpdatePasswordLoading } = useSelector(
    (state) => state.UpdatePassword
  );
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [passwordStartMessage, setPasswordStartMessage] = useState({
    error: false,
    message: "",
  });
  const [showincon, setshowicon] = useState("mdi mdi-eye");
  const getQueryParams = () => {
    const urlParams = new URLSearchParams(location.search);
    console.log(urlParams, " : aaaaaa");
    const patientid = urlParams.get("Id");
    const token = urlParams.get("Token");
    return { patientid, token };
  };

  const { patientid, token } = getQueryParams();
  const showPassword = () => {
    var x = document.getElementById("password");
    if (x.type === "password") {
      setshowicon("mdi mdi-eye-off");
      x.type = "text";
    } else {
      setshowicon("mdi mdi-eye");
      x.type = "password";
    }
  };
  const resetPasswordFunc = async () => {
    let password = document.getElementById("password").value;
    let confirmPassword = document.getElementById("confirmPassword").value;

    const passwordError = passwordValidator(password);
    const cnfrmPaswrd = passwordValidator(confirmPassword);
    if (passwordError) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Password cannot be empty ",
      }));

      return;
    }
    if (cnfrmPaswrd) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Confirm Password cannot be empty",
      }));

      return;
    }
    if (password !== confirmPassword) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Passwords did not matched. Please try again",
      }));

      return;
    }
    //check for lower case
    if (!password.match(/[a-z]/)) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Password must contain at least one lower case letter.",
      }));
      return;
    }

    //Validating length
    if (password.length < 8) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Your password has less than 8 characters.",
      }));

      // alert("Your password has less than 8 characters.");
      return;
    }

    //check for upper ase
    if (!password.match(/[A-Z]/)) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Password must contain at least one upper case letter.",
      }));

      // alert("Password must contain at least one upper case letter.");
      // passForm.passInput.focus();
      return;
    }
    var patt = new RegExp("^(?=(.*[a-zA-Z]){1,})(?=(.*[0-9]){2,}).{8,}$");
    //check for number
    if (!patt.test(password)) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Password must contain at least two number.",
      }));

      // alert("Password must contain at least two number.");
      // passForm.passInput.focus();
      return;
    }
    if (!recaptchToken) {
      setPasswordStartMessage((prevState) => ({
        ...prevState,
        error: true,
        message: "Please complete the reCAPTCHA to proceed.",
      }));
      // document.getElementById("errorMessage").innerHTML = "Please complete the reCAPTCHA to proceed.";
      return;
    }
    setIsResetPassword(true);
    const payload = {
      Id: patientid,
      Token: token,
      NewPassword: password,
      ConfirmPassword: confirmPassword,
    };

    dispatch(appServices.UpdatePassword(payload));
  };
  useEffect(() => {
    console.log(UpdatePasswordData, "UpdatePasswordData");
    if (UpdatePasswordData) {
      if (UpdatePasswordData.StatusCode == "1") {
        // for activity indicatorr
        setIsResetPassword(false);
        setPasswordStartMessage((prevState) => ({
          ...prevState,
          error: false,
          message: UpdatePasswordData.StatusMessage,
        }));
        PortalAlerts("success", "success", UpdatePasswordData.ResponseMessage);
        navigate("/login");
        console.log("statscode==1==>" + JSON.stringify(UpdatePasswordData));
        // handleCloseReset()
      }
      // {"StatusCode":3,"StatusMessage":"three time password error try to some differect passsword"}
      if (UpdatePasswordData.StatusCode == "3") {
        setPasswordStartMessage((prevState) => ({
          ...prevState,
          error: true,
          message: UpdatePasswordData.StatusMessage,
        }));
        PortalAlerts("warning", "warning", UpdatePasswordData.StatusMessage);

        setIsResetPassword(false);
        console.log("statscode==2==>" + JSON.stringify(UpdatePasswordData));
      }
      if (UpdatePasswordData.StatusCode == "2") {
        setPasswordStartMessage((prevState) => ({
          ...prevState,
          error: true,
          message: UpdatePasswordData.StatusMessage,
        }));
        PortalAlerts("error", "error", UpdatePasswordData.StatusMessage);

        setIsResetPassword(false);
        console.log("statscode==2==>" + JSON.stringify(UpdatePasswordData));
      }
      dispatch(appServices.gettingUpdatePasswordClear());
    }
  }, [UpdatePasswordData]);

  const showPasswordConfirm = () => {
    var x = document.getElementById("confirmPassword");
    if (x.type === "password") {
      setshowicon("mdi mdi-eye-off");
      x.type = "text";
    } else {
      setshowicon("mdi mdi-eye");
      x.type = "password";
    }
  };
  const onChangeRecaptch = (value) => {
    setrecaptchToken(value);
  };
  const onExpired = () => {
    setrecaptchToken(""); // Reset verification status when reCAPTCHA expires
    setPasswordStartMessage((prevState) => ({
      error: false,
      message: "",
    }));
  };
  return (
    <div className="authentication-theme auth-style_1">
      <div className="row">
        <div className="col-12 logo-section">
          <a href="#" className="logo">
            <img
              src="https://devnhlapp.indici.ie/Images/mainLogo-indici-140X40.svg"
              alt="logo"
            />
          </a>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-5 col-md-7 col-sm-9 col-11 mx-auto">
          <div className="grid">
            <div className="grid-body">
              <div className="row">
                <div className=" mx-auto form-wrapper">
                  <div>
                    <View
                      style={{
                        backgroundColor: "#d1ecf1",
                        padding: 10,
                        marginBottom: 5,
                      }}
                    >
                      <Text style={{ fontWeight: "bold" }}>Password Rules</Text>
                      <Text style={{}}>
                        Password must be at least 8 characters.
                      </Text>
                      <Text style={{}}>
                        Password must contain at least one alphabet and two
                        digits.
                      </Text>
                      <Text style={{}}>
                        Password must not contain first, middle or family name.
                      </Text>
                      <Text style={{}}>Example: abc12345 or Abc@1234</Text>
                    </View>

                    <div className="form-group">
                      <div className="input-group">
                        <input
                          id="password"
                          type="password"
                          className="form-control"
                          placeholder="Password"
                        />
                        <div className="input-group-append">
                          <div
                            onClick={() => showPassword()}
                            className="input-group-text"
                          >
                            <i className={showincon}></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="input-group">
                        <input
                          id="confirmPassword"
                          type="password"
                          className="form-control"
                          placeholder="Password"
                        />
                        <div className="input-group-append">
                          <div
                            onClick={() => showPasswordConfirm()}
                            className="input-group-text"
                          >
                            <i className={showincon}></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group input-rounded">
                      <p id="errorMessageReset" style={{ color: "red" }}></p>
                    </div>
                    {isResetPassword && (
                      <View style={{ textAlign: "center", marginBottom: 5 }}>
                        <ActivityIndicator size="small" color="#00A1DE" />
                      </View>
                    )}
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={Settings.recaptchaKey}
                      onChange={onChangeRecaptch}
                      onExpired={onExpired}
                      // theme='dark'
                      badge="inline"
                    />
                    {passwordStartMessage.error && (
                      <View style={{ textAlign: "center", marginBottom: 5 }}>
                        <Text style={{ color: "red" }}>
                          {passwordStartMessage.message}
                        </Text>
                      </View>
                    )}
                    <button
                      onLoad={isUpdatePasswordLoading}
                      onClick={() => resetPasswordFunc()}
                      className="btn btn-primary btn-block mt-2"
                    >
                      Update Password{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="auth_footer">
        <p className="text-muted text-center">© indici 2020</p>
      </div>
    </div>
  );
};

export default UpdatePassword;
